import styled from 'styled-components';

const General =  styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  /* height: 85%; */
  color: white;
  /* padding: 8% 0  0 0; */
  /* margin: 0 auto; */
`;

const AuthModal =  styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 60vw;
  height: 60vh;
  background-image: url("https://res.cloudinary.com/dojodevs/image/upload/v1574746795/smartia/RECURSOS/STOCK_HAL_03_uuk1xj.jpg");
  background-size:     cover;
  background-repeat:   no-repeat;
  background-position: center center;
  margin: 10%;
`;

const Button = styled.button`
  background: ${props => props.auth ? "#262237" : "red"};
  color: ${props => props.auth ? "white" : "green"};
  font-size: 1em;
  margin: 1em;
  padding: 0.25em 1em;
  border-radius: 3px;
`;

export { General, AuthModal, Button }